var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group"},_vm._l((_vm.groups),function(item,index){return _c('div',{key:item.groupId || '',staticClass:"groupitem",class:{ islastitem: Number(index) < (_vm.groups.length-1)},on:{"click":function($event){$event.preventDefault();return _vm.chooseGroup(item)}}},[_vm._v("\n      "+_vm._s(item.groupName)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }